import { render, staticRenderFns } from "./SignalsCard.vue?vue&type=template&id=6271d6d9&scoped=true"
import script from "./SignalsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SignalsCard.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SignalsCard.vue?vue&type=style&index=0&id=6271d6d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6271d6d9",
  null
  
)

export default component.exports